import styled, { css } from 'styled-components';

type ExpiryTone = 'warning' | 'danger';

const Badge = styled.span<{ $tone: ExpiryTone }>`
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: none;
  letter-spacing: 0.04em;
  line-height: 1;
  white-space: nowrap;

  ${(props) =>
    props.$tone === 'danger'
      ? css`
          background: var(--danger-100);
          color: var(--danger-600);
        `
      : css`
          background: var(--warning-100);
          color: var(--warning-600);
        `}
`;

interface ComplianceExpiryBadgeProps {
  expired: boolean;
  expiringSoon: boolean;
  daysToExpiry?: number | null;
  className?: string;
}

export const ComplianceExpiryBadge = ({
  expired,
  expiringSoon,
  daysToExpiry,
  className,
}: ComplianceExpiryBadgeProps) => {
  if (!expired && !expiringSoon) {
    return null;
  }

  const tone: ExpiryTone = expired ? 'danger' : 'warning';
  const label = expired
    ? 'Vencido'
    : daysToExpiry != null
      ? `Vence en ${daysToExpiry}d`
      : 'Vence pronto';

  return (
    <Badge className={className} $tone={tone}>
      {label}
    </Badge>
  );
};

ComplianceExpiryBadge.displayName = 'ComplianceExpiryBadge';
